<div class="w-full flex flex-col" style="height: 100%;">
  <app-table-loading-overlay></app-table-loading-overlay>
  <div class="flex items-start justify-between gap-3">
    <div #title class="font-bold uppercase text-surface-900" style="font-size: 18px;">
      {{ widgetHeader() }}
    </div>

    <div #action class="flex items-center gap-2">
      <p-select [options]="rangeOptions" optionLabel="label" optionValue="value" [formControl]="rangeControl"
        class="earnings-range-select"></p-select>
    </div>
  </div>

  <div class="mt-5 shrink-0">
    <p-chart #chartRef *ngIf="data() && options()" type="bar" [data]="data()" [options]="options()"
      [plugins]="plugins()"></p-chart>
    <div class="flex flex-wrap gap-2 mt-2 justify-end">
      <div class="flex flex-wrap gap-2 mt-0 ">
        <button type="button" *ngFor="let chip of legendChips" class="legend-tag-btn" [class.is-hidden]="chip.hidden"
          (click)="toggleDataset(chip)">
          <p-tag class="legend-tag" [value]="chip.label" [style.--legend-color]="chip.color"
            [style.--legend-bg]="withAlpha(chip.color, 0.14)" [style.--legend-border]="withAlpha(chip.color, 0.22)">
          </p-tag>
        </button>
      </div>
    </div>
  </div>
  <div class="mt-10 flex-1 min-h-0">
    <p-treetable [value]="store.costCenterTurnoverNodes()" (onNodeExpand)="onNodeExpand($event)" [scrollable]="true" scrollHeight="flex"
      [lazy]="true" [tableStyle]="{ 'min-width': '60rem' }">
      <ng-template pTemplate="header">
        <tr>
          <th>Betrieb</th>
          <th>Umsatz</th>
          <th>Differenz zur Vorperiode</th>
          <th></th>
        </tr>
      </ng-template>

      <ng-template #body let-rowNode let-rowData="rowData">
        <tr [ttRow]="rowNode">
          <td>
            <div class="flex items-center gap-2">
              <p-treetable-toggler [rowNode]="rowNode" />
              <span>{{ rowData.name }}</span>
            </div>
          </td>
          <td><span >{{ rowData.actualSales | currency:'EUR':'symbol':'1.2-2':'de-DE' }}</span></td>
          <td><span >{{ rowData.targetSales | currency:'EUR':'symbol':'1.2-2':'de-DE' }}</span></td>
          <td style="text-align: end;"><span >{{ rowData.difference / 100 | percent : '1.0-1' }}</span></td>
        </tr>
      </ng-template>
    </p-treetable>
  </div>
</div>